import React from "react";
import MetaData from "../../components/layout/MetaData";
import Hero from "./Hero";
import FeaturedCategories from "./FeaturedCategories";
import AboutCreatyea from "./AboutCreatyea";
import SubscribeNewsletter from "./SubscribeNewsletter";

/**
 * 首页组件
 * TODO: 如需恢复首页商品推荐区，可重新引入并渲染 FeaturedProducts。
 */
const HomePage = () => {
  return (
    <>
      <MetaData title={"Buy Best Products Online"} />
      <Hero />
      <FeaturedCategories />  
      <AboutCreatyea />
      <SubscribeNewsletter />
    </>
  );
};

export default HomePage;
